import React, { useState, useEffect, useMemo } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Label,
    Button,
    Input,
    Badge,
    Table,
    Spinner,
    // UncontrolledTooltip
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as productAction from "../../../store/c2FsZXNQeXJhbWlkUm/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import api from "helpers/Api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
    PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { ToastContainer, toast } from "react-toastify"
//import ProductTableComponent from "./ProductTableComponent"
import CanvasJSReact from '@canvasjs/react-charts'
import { Slider, InputNumber } from 'antd'
//import "./styles.scss"

const SalesPyramidReports = (props) => {
    const { searchBtnStyle, dispatch } = props
    var CanvasJSChart = CanvasJSReact.CanvasJSChart
    const title = "Sales Pyramid Report"
    const today = moment().format("YYYY-MM-DD")
    const thirtyDaysBefore = moment().subtract(30, 'days').format("YYYY-MM-DD")
    const [productStatusData, setProductStatusData] = useState({
        eventFromDate: "",
        eventToDate: "",
        leadFromDate: thirtyDaysBefore,
        leadToDate: today,
        followupFromDate: "",
        followupToDate: "",
        budgetRange: ""
    })

    //Fetching API
    useEffect(() => {
        dispatch(productAction.loadProductStatus({
            page: 1,
            limit: 50,
            leadFromDate: thirtyDaysBefore,
            leadToDate: today,
        }))
        dispatch(productAction.loadRecordsMetaData())
    }, [])
    //Date format
    const sessionUpdate = useSelector((specificstate) => specificstate.session)
    const { user = [] } = sessionUpdate

    const dateSetting =
        !isEmpty(user) && user.setting && user.setting.dateFormate
            ? user.setting.dateFormate.toUpperCase()
            : []
    const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
    //date format
    const update = useSelector((specificstate) => specificstate.salesPyramidReports)
    console.log(dateFormat, "update")
    //product_data
    const { product_data = [], recordsMetaData = {} } = update

    const [employee, setEmployee] = useState([])
    const [company, setCompany] = useState([])
    const [branch, setBranch] = useState([])
    const [leadSource, setLeadSource] = useState([])
    //pyramid
    const pyramidData = product_data && !isEmpty(product_data.pyramidData) ? product_data.pyramidData : []

    // const pyramidDataValues = useMemo(() => {
    //     return !isEmpty(pyramidData)
    //         ? pyramidData
    //             .filter(m => m._id != null)
    //             .map((data) => {
    //                 // Assign specific colors based on the label
    //                 let color
    //                 switch (data._id) {
    //                     case "Active":
    //                         color = "#12af46" // Green
    //                         break
    //                     case "Hot":
    //                         color = "#f9851b" // Red
    //                         break
    //                     case "Potential":
    //                         color = "#3B71CA" // Blue
    //                         break
    //                     case "Inactive":
    //                         color = "#df2707" // Black
    //                         break
    //                     default:
    //                         color = "#CCCCCC" // Default color (gray) for any other labels
    //                         break
    //                 }
    //                 return { label: data._id, y: data.count, color } // Assign the determined color
    //             })
    //             .sort((a, b) => b.y - a.y) // Sort by count in descending order
    //         : []
    // }, [pyramidData])
    const pyramidDataValues = useMemo(() => {
        return !isEmpty(pyramidData)
            ? pyramidData
                .filter(m => m._id != null)
                .map((data) => {
                    // Assign specific colors based on the label
                    let color
                    switch (data._id) {
                        case "Active":
                            color = "#12af46" // Green
                            break
                        case "Hot":
                            color = "#f9851b" // Red
                            break
                        case "Potential":
                            color = "#3B71CA" // Blue
                            break
                        case "Inactive":
                            color = "#df2707" // Black
                            break
                        case "Yet To Audit":
                            color = "#b1b1b1" // Black
                            break
                        default:
                            color = "#CCCCCC" // Default color (gray) for any other labels
                            break
                    }
                    return { label: data._id, y: data.count, color } // Assign the determined color
                })
                .sort((a, b) => b.y - a.y) // Sort by count in descending order
            : [] // Return empty array if pyramidData is empty
    }, [pyramidData])
    console.log(pyramidDataValues, "pyramiddata")
    const [pyramidOptions, setPyramidOptions] = useState({
        animationEnabled: true,
        title: {
            text: "Sales Pyramid",
        },
        legend: {
            horizontalAlign: "right",
            verticalAlign: "center",
            reversed: true,
        },
        data: [
            {
                type: "pyramid",
                showInLegend: true,
                legendText: "{label}",
                indexLabel: "{label} - {y}",
                toolTipContent: "<b>{label}</b>: {y} <b>({percentage}%)</b>",
                dataPoints: [],

            },
        ],
    })
    const branchListOptions =
        !isEmpty(recordsMetaData) &&
        recordsMetaData.branchOptions.filter(
            (branch) => branch.companyId === company.value
        )
    // useEffect(() => {
    //     if (pyramidDataValues.length > 0) {
    //         const dataPoints = [...pyramidDataValues]
    //         const total = dataPoints[0]?.y || 1 // Ensure total is not zero to avoid division errors

    //         // Calculate percentage for each data point
    //         dataPoints.forEach((point, i) => {
    //             point.percentage = i === 0 ? 100 : ((point.y / total) * 100).toFixed(2)
    //         })

    //         // Update pyramid options with the calculated dataPoints
    //         setPyramidOptions((prevOptions) => ({
    //             ...prevOptions,
    //             data: [{ ...prevOptions.data[0], dataPoints }],
    //         }))
    //     } else {
    //         // Reset pyramid options if no data is available
    //         setPyramidOptions((prevOptions) => ({
    //             ...prevOptions,
    //             data: [{ ...prevOptions.data[0], dataPoints: [] }],
    //         }))
    //     }
    // }, [pyramidDataValues])

    useEffect(() => {
        if (pyramidDataValues.length > 0) {
            const dataPoints = [...pyramidDataValues]
            const total = dataPoints[0]?.y || 1 // Ensure total is not zero to avoid division errors

            dataPoints.forEach((point, i) => {
                if (i === 0) {
                    point.percentage = 100
                } else {
                    point.percentage = ((point.y / total) * 100).toFixed(2)
                }
            })

            // Update the pyramidOptions only when dataPoints changes
            setPyramidOptions((prevOptions) => ({
                ...prevOptions,
                data: [{ ...prevOptions.data[0], dataPoints }],
            }))
        }
    }, [pyramidDataValues])

    const [pyramidStatus, setPyramidStatus] = useState([])
    //range value
    const [isRange, setIsRange] = useState(false)
    const [rangeValue, setRangeValue] = useState([1, 1000000])
    const handleRangeChange = (val) => {
        setRangeValue(val)
        setIsRange(true)
    }


    // Handle the min value change
    const handleMinChange = (newMin) => {
        const newRange = [newMin, rangeValue[1]]
        if (newMin > rangeValue[1]) {
            setRangeValue([newMin, newMin])
            setIsRange(true)
        } else {
            setRangeValue(newRange)
            setIsRange(true)
        }
    }

    // Handle the max value change
    const handleMaxChange = (newMax) => {
        const newRange = [rangeValue[0], newMax]
        if (newMax < rangeValue[0]) {
            setRangeValue([newMax, newMax])
            setIsRange(true)
        } else {
            setRangeValue(newRange)
            setIsRange(true)
        }
    }
    const handleChange = (e) => {
        setProductStatusData({ ...productStatusData, [e.target.name]: e.target.value })
    }

    const [downloadLoading, setDownloadLoading] = useState(false)
    //Search value


    const [btnLoader, setBtnLoader] = useState(false)

    const [pageCount, setPageCount] = useState(false)
    const [pageChange, setPageChange] = useState(false)

    //const [searchValue, setSearchValue] = useState({})
    const handleFilter = (e) => {
        e.preventDefault()
        var searchCompany = !isEmpty(company) && company ? company.value : ""
        var searchBranch = !isEmpty(branch) && branch ? branch.value : ""
        var searchSource = !isEmpty(leadSource) && leadSource ? leadSource.value : ""
        // var searchBudget =   productStatusData && productStatusData.budget

        var searchEmployee = !isEmpty(employee) && employee ? employee.value : ""

        var searchFromDate =
            productStatusData && productStatusData.eventFromDate
                ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            productStatusData && productStatusData.eventToDate
                ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
                : ""
        var searchFromRange = !isEmpty(rangeValue) ? rangeValue[0] : ""
        var searchToRange = !isEmpty(rangeValue) ? rangeValue[1] : ""
        var searchFollowupFromDate =
            productStatusData && productStatusData.followupFromDate
                ? moment(productStatusData.followupFromDate).format("YYYY-MM-DD")
                : ""
        var searchFollowupToDate =
            productStatusData && productStatusData.followupToDate
                ? moment(productStatusData.followupToDate).format("YYYY-MM-DD")
                : ""
        var searchLeadFromDate =
            productStatusData && productStatusData.leadFromDate
                ? moment(productStatusData.leadFromDate).format("YYYY-MM-DD")
                : ""
        var searchLeadToDate =
            productStatusData && productStatusData.leadToDate
                ? moment(productStatusData.leadToDate).format("YYYY-MM-DD")
                : ""
        var searchPyramid = !isEmpty(pyramidStatus) && pyramidStatus ? pyramidStatus.value : ""
        var searchvalue = {}
        searchvalue.page = pageChange ? pageCount : 1
        searchvalue.limit = sizePerPage ? sizePerPage : 50

        if (searchEmployee) {
            searchvalue.salesManagerId = searchEmployee
        }
        if (searchFromDate) {
            searchvalue.eventFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.eventToDate = searchToDate
        }
        if (searchCompany) {
            searchvalue.companyId = searchCompany
        }
        if (searchBranch) {
            searchvalue.branchId = searchBranch
        }
        if (searchSource) {
            searchvalue.leadSourceId = searchSource
        }
        if (searchFollowupFromDate) {
            searchvalue.followupFromDate = searchFollowupFromDate
        }
        if (searchFollowupToDate) {
            searchvalue.followupToDate = searchFollowupToDate
        }
        if (searchLeadFromDate) {
            searchvalue.leadFromDate = searchLeadFromDate
        }
        if (searchLeadToDate) {
            searchvalue.leadToDate = searchLeadToDate
        }
        if (isRange) {
            if (searchFromRange) {
                searchvalue.budgetFromRange = searchFromRange
            }
            if (searchToRange) {
                searchvalue.budgetToRange = searchToRange
            }
        }
        if (searchPyramid) {
            searchvalue.pyramidStatus = searchPyramid
        }
        //  setSearchValue(searchvalue)
        dispatch(productAction.loadProductStatus(searchvalue))
        setBtnLoader(true)
        setTimeout(() => {
            setBtnLoader(false)
        }, 3000)


    }

    //reset

    const resetForm = () => {
        setEmployee([])
        setSearchInput("")
        setPyramidStatus([])
        //   setSearchValue({})
        setCompany([])
        setBranch([])
        setPageCount(1)

        setLeadSource([])

        setProductStatusData({
            ...productStatusData,
            eventFromDate: "",
            eventToDate: "",
            leadFromDate: thirtyDaysBefore,
            leadToDate: today,
            followupFromDate: "",
            followupToDate: "",
            budgetRange: ""
        })
        setRangeValue([1, 1000000])
        setIsRange(false)
        dispatch(productAction.loadProductStatus({
            page: 1,
            limit: 50
        }))
    }
    //
    const [pyramidModal, setPyramidModal] = useState(false)
    const [salesPyramidDetails, setSalesPyramidDetails] = useState()
    const [followupHistoryModal, setFollowupHistoryModal] = useState(false)
    const handleFollowupHistoryModal = () => {
        setFollowupHistoryModal(false)
    }
    const [followupHistoryDetails, setFollowupHistoryDetails] = useState([])
    //
    const productStatusTable = !isEmpty(product_data) && product_data.data.length > 0 ?
        product_data.data.map((data, index) => {
          
                const eventDateValue = !isEmpty(data.eventDate)
                ? data.eventDate
                  .map((m) => moment(m).format(dateFormat))
                  .reduce((result, date, index) => {
        
                    const groupIndex = Math.floor(index / 2)
                    result[groupIndex] = result[groupIndex] || []
                    result[groupIndex].push(date)
                    return result
                  }, [])
                  .map((group) => group.join(", "))
                  .join("\n")
                : "--"
                const venueArray =data.venueName ? (data?.venueName || "--").split(',').map(v => v.trim()) :[]
                const venueValue = !isEmpty(venueArray)
                ? venueArray
                  .map((m) =>m)
                  .reduce((result, date, index) => {
        
                    const groupIndex = Math.floor(index / 2)
                    result[groupIndex] = result[groupIndex] || []
                    result[groupIndex].push(date)
                    return result
                  }, [])
                  .map((group) => group.join(", "))
                  .join("\n")
                : "--"
            
            return {
                _id: index,
                sNo: index + 1,
                leadNo: data.leadNo ? data.leadNo : "--",
                clientAppearanceRating: data.clientAppearanceRating ? data.clientAppearanceRating : "--",
                companyName: data.companyName ? data.companyName : "--",
                branchName: data.branchName ? data.branchName : "--",
                followupDate: data.followupDate ? moment(data.followupDate).format(dateFormat) : "--",
                venueName:venueValue,
                eventDate: eventDateValue,
                followupCount: data.followupCount,
                eventFollowupCount: `${data.eventDaysCount} / ${data.nextFollowupDaysCount}`,
                isPremium: data.isPremium,
                salesUrge: data.salesUrge ? data.salesUrge : "--",
                discountPercentage: data.discountPercentage ? data.discountPercentage : "--",
                budget: data.budgetValue,
                processStatus: data.processStatusName ? data.processStatusName : "--",
                clientStatus: data.clientStatus ? data.clientStatus : "--",
                officeVisit: data.officeVisit == true ? "YES" : "NO",
                followupMode: data.followupMode ? data.followupMode : "--",
                clientName: data.clientName ? data.clientName : "--",
                salesAgent: data.salesAgent ? data.salesAgent : "--",
                mobile: data.mobile ? data.mobile : "--",
                strategyRemark: data.strategyRemark ? data.strategyRemark : "--",
                clientPriority: data.priorityStatusName ? data.priorityStatusName : "--",
                agingDate: data.agingDaysCount + "/" + data.reAssigningDaysCount,
                salesPyramid: data.salesPyramid && data.salesPyramid != null ? data.salesPyramid : "Yet To Audit",
                leadSource: data.leadSourceName ? data.leadSourceName : "--",
                followupHistory: data.followupHistory,
                zgClient: !isEmpty(data.zgPlusOneClient) ? data.zgPlusOneClient.map(m => m).join(",") : "--",
                greenFlagRemarks: data.greenFlagRemarks ? data.greenFlagRemarks : "--",
                averageFollowup: data.averageFollowup ? data.averageFollowup : "--",
                goodLookingClient: data.goodLookingClient,
                highEndClient: data.highEndClient
            }


        }) : []

    const initialColumns = [
        {
            dataField: "sNo",
            text: "S.No",
            hidden: false,

        },
        {
            dataField: "leadNo",
            text: "Lead No",
            hidden: false,
            style: () => ({

                textTransform: "uppercase",
                color: "#e40d8c",
            }),
            headerStyle: {
                minWidth: "125px",
            },
        },
        {
            dataField: "goodLookingClient",
            text: "Good Looking Client",
            hidden: true,
            editable: false,
            formatter: (cellContent) => {
                return (
                    <Row>
                        <Col md="8" lg="8" sm="8">
                            <div style={{ textAlign: "center", justifyContent: "center" }}>

                                {cellContent == true ? <span
                                    className={"badge"}
                                    style={{
                                        display: "inline-block",
                                        width: "35px",
                                        height: "35px",
                                        borderRadius: "50%",
                                        color: "#FFD700",
                                        backgroundColor: "#BF55EC"
                                    }}
                                /> : "--"}
                            </div>
                        </Col>

                    </Row>
                )


            },

            headerStyle: {
                minWidth: "190px",
            },
        },
        {
            dataField: "highEndClient",
            text: "High End Client",
            hidden: true,
            editable: false,
            formatter: (cellContent) => {
                return (
                    <Row>
                        <Col md="8" lg="8" sm="8">
                            <div style={{ textAlign: "center", justifyContent: "center" }}>

                                {cellContent == true ? <span
                                    className={"badge"}
                                    style={{
                                        display: "inline-block",
                                        width: "35px",
                                        height: "35px",
                                        borderRadius: "50%",
                                        color: "#BF55EC",
                                        backgroundColor: "#FFD700"

                                    }}
                                /> : "--"}
                            </div>
                        </Col>

                    </Row>
                )


            },

            headerStyle: {
                minWidth: "190px",
            },
        },
        {
            dataField: "clientAppearanceRating",
            text: "Client Appearance Rating",

            hidden: false,
            headerStyle: {
                minWidth: "230px",
            },
        },
        {
            dataField: "companyName",
            text: "Company",

            hidden: false,
            headerStyle: {
                minWidth: "130px",
            },
        },
        {
            dataField: "branchName",
            text: "Branch",

            hidden: false,
            headerStyle: {
                minWidth: "120px",
            },
        },
        {
            dataField: "followupDate",
            text: "Followup Date",

            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "venueName",
            text: "Venue Name",

            hidden: false,
            headerStyle: {
                minWidth: "135px",
            },
        },
        {
            dataField: "eventDate",
            text: "Event Date",

            hidden: false,
            headerStyle: {
                minWidth: "135px",
            },
        },
        {
            dataField: "followupCount",
            text: "Followup Count",

            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "averageFollowup",
            text: "Average Followup",
            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "eventFollowupCount",
            text: "Event Date / Next Followup Date",

            hidden: false,
            headerStyle: {
                minWidth: "265px",
            },
        },
        {
            dataField: "isPremium",
            text: "Premium",
            formatter: (cellContent, row) => {
                return (
                    <Badge
                        color={row.isPremium === true ? "success" : "danger"}
                        style={{ padding: "8px 14px", fontSize: "12px" }}
                    >
                        {" "}
                        {row.isPremium == true ? "Yes" : "No"}
                    </Badge>
                )
            },
            hidden: false,
            headerStyle: {
                minWidth: "120px",
            },

        },
        {
            dataField: "salesUrge",
            text: "Sales Urge",

            hidden: false,
            headerStyle: {
                minWidth: "130px",
            },
        },
        {
            dataField: "discountPercentage",
            text: "Discount Percentage",

            hidden: false,
            headerStyle: {
                minWidth: "190px",
            },
        },
        {
            dataField: "budget",
            text: "Total Value / Budget",

            hidden: false,
            headerStyle: {
                minWidth: "200px",
            },
        },

        {
            dataField: "processStatus",
            text: "Process Status",

            hidden: false,
            headerStyle: {
                minWidth: "150px",
            },
        },
        {
            dataField: "clientStatus",
            text: "Client Status",
            hidden: false,
            headerStyle: {
                minWidth: "138px",
            },
        },

        {
            dataField: "officeVisit",
            text: "Office Visit",

            hidden: false,
            headerStyle: {
                minWidth: "150px",
            },
        },
        {
            dataField: "followupMode",
            text: "Follow Up Mode",

            hidden: false,
            headerStyle: {
                minWidth: "150px",
            },
        },
        {
            dataField: "clientName",
            text: "Client Name",

            hidden: false,
            headerStyle: {
                minWidth: "150px",
            },
        },

        {
            dataField: "salesAgent",
            text: "SalesAgent",

            hidden: false,
            headerStyle: {
                minWidth: "150px",
            },
        },
        {
            dataField: "mobile",
            text: "Mobile",

            hidden: false,
            headerStyle: {
                minWidth: "155px",
            },
        },
        {
            dataField: "strategyRemark",
            text: "Strategy Remark",

            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "clientPriority",
            text: "Client Priority",

            hidden: false,
            headerStyle: {
                minWidth: "160px",
            },

        },
        {
            dataField: "agingDate",
            text: "Aging/Re-assigning",

            hidden: false,
            headerStyle: {
                minWidth: "270px",
            },
        },
        {
            dataField: "salesPyramid",
            text: "Pyramid Status",

            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "leadSource",
            text: "Lead Source",

            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "followupHistory",
            text: "Followup History",
            formatter: (cellContent, row) => {
                return (
                    <Row>
                        <Col md="6" lg="6" sm="6">
                            {row.followupCount ? <div className="space-between">
                                <span className="badge rounded-pill bg-primary">
                                    {row.followupCount}
                                </span>
                            </div> : "--"}

                        </Col>
                        <Col md="4" lg="4" sm="4">
                            <i
                                className="fas fa-eye text-info fs-5"
                                onClick={() => {
                                    setFollowupHistoryDetails(row.followupHistory)
                                    setFollowupHistoryModal(true)
                                }}
                            ></i>
                        </Col>
                    </Row>

                )
            },
            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "zgClient",
            text: "ZG + 1 Clients",

            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        //ZG + 1 Clients
        {
            dataField: "salePyramid",
            text: "Sale Pyramid History",

            hidden: false,
            formatter: (cellContent, row) => {
                return (
                    <div
                        className="ms-auto ml-2"
                        onClick={() => {
                            setSalesPyramidDetails(row.salesPyramidHistory)
                            setPyramidModal(true)
                        }}
                    >
                        <i
                            className="fas fa-eye"
                            style={{ color: "#50a5f1", fontSize: "15px" }}
                        ></i>
                    </div>
                )
            },
            headerStyle: {
                minWidth: "170px",
            },
        },
        {
            dataField: "greenFlagRemarks",
            text: "Green Flag Remarks",

            hidden: false,
            headerStyle: {
                minWidth: "185px",
            },
        },
    ]
    //edit columns
    const [columns, setColumns] = useState(initialColumns)
    const [columnModal, setColumnModal] = useState(false)
    const [oddColumnData, setOddColumnData] = useState([])
    const [evenColumnData, setEvenColumnData] = useState([])
    useEffect(() => {
        if (columns && columns.length > 0) {
            var array = columns
            var evenColumns = []
            var oddColumns = []

            for (var i = 0; i < array.length; i++) {
                if (i % 2 === 0) {
                    oddColumns.push(array[i])
                } else {
                    evenColumns.push(array[i])
                }
            }

            setOddColumnData(oddColumns)
            setEvenColumnData(evenColumns)
        }
    }, [columns])

    const selectColumn = columns
        .filter((column) => column.hidden === false)
        .map((column) => column.dataField)

    const [selectedColumns, setSelectedColumns] = useState(selectColumn)

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target

        let updatedSelectedColumns
        if (checked) {
            updatedSelectedColumns = [...selectedColumns, value]
        } else {
            updatedSelectedColumns = selectedColumns.filter(
                (column) => column !== value
            )
        }

        setSelectedColumns(updatedSelectedColumns)
    }

    //  "Select All" checkbox
    const handleSelectAllChange = (e) => {
        const { checked } = e.target
        if (checked) {
            const allColumns = columns.map((column) => column.dataField)
            setSelectedColumns(allColumns)
        } else {
            const restoredColumns = initialColumns
                .filter((column) => !column.hidden)
                .map((column) => column.dataField)
            setSelectedColumns(restoredColumns)
        }
    }

    const handleSaveColumns = () => {
        setColumnModal(false)

        const updatedColumns = columns.map((column) => {
            const isColumnSelected = selectedColumns.includes(column.dataField)
            return { ...column, hidden: !isColumnSelected }
        })

        setColumns(updatedColumns)
        // default columns
        const defaultColumns = initialColumns.filter((column) => !column.hidden)
        const selectedNonDefaultColumns = selectedColumns.filter(
            (column) =>
                !defaultColumns.some(
                    (defaultColumn) => defaultColumn.dataField === column
                )
        )

        if (selectedNonDefaultColumns.length > 0) {
            toast.success("New Columns added successfully!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
            })
        }
    }

    const handleRestoreToDefault = () => {
        const restoreColumns = initialColumns
            .filter((column) => !column.hidden)
            .map((column) => column.dataField)

        setSelectedColumns(restoreColumns)
    }

    const [loading, setLoading] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [searchFilter, setSearchFilter] = useState(false)


    const handleClick = (e) => {
        e.preventDefault()
        setSearchFilter(true)
        dispatch(productAction.loadProductStatus({
            searchFilter: searchInput,
            page: pageChange ? pageCount : 1,
            limit: 50,

        }))
        setTimeout(() => {
            setSearchFilter(false)
        }, 1200)
    }
    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })

        const a = document.createElement("a")
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    const exportToCsv = () => {

        var searchCompany = !isEmpty(company) && company ? company.value : ""
        var searchBranch = !isEmpty(branch) && branch ? branch.value : ""
        var searchSource = !isEmpty(leadSource) && leadSource ? leadSource.value : ""

        var searchEmployee = !isEmpty(employee) && employee ? employee.value : ""
        var searchPyramid = !isEmpty(pyramidStatus) && pyramidStatus ? pyramidStatus.value : ""
        var searchFromDate =
            productStatusData && productStatusData.eventFromDate
                ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            productStatusData && productStatusData.eventToDate
                ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
                : ""
        var searchFromRange = !isEmpty(rangeValue) ? rangeValue[0] : ""
        var searchToRange = !isEmpty(rangeValue) ? rangeValue[1] : ""
        var searchFollowupFromDate =
            productStatusData && productStatusData.followupFromDate
                ? moment(productStatusData.followupFromDate).format("YYYY-MM-DD")
                : ""
        var searchFollowupToDate =
            productStatusData && productStatusData.followupToDate
                ? moment(productStatusData.followupToDate).format("YYYY-MM-DD")
                : ""
        var searchLeadFromDate =
            productStatusData && productStatusData.leadFromDate
                ? moment(productStatusData.leadFromDate).format("YYYY-MM-DD")
                : ""
        var searchLeadToDate =
            productStatusData && productStatusData.leadToDate
                ? moment(productStatusData.leadToDate).format("YYYY-MM-DD")
                : ""
        var searchvalue = {}
        if (searchPyramid) {
            searchvalue.pyramidStatus = searchPyramid
        }

        if (searchEmployee) {
            searchvalue.salesManagerId = searchEmployee
        }
        if (searchFromDate) {
            searchvalue.eventFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.eventToDate = searchToDate
        }
        if (searchCompany) {
            searchvalue.companyId = searchCompany
        }
        if (searchBranch) {
            searchvalue.branchId = searchBranch
        }
        if (searchSource) {
            searchvalue.leadSourceId = searchSource
        }
        if (searchFollowupFromDate) {
            searchvalue.followupFromDate = searchFollowupFromDate
        }
        if (searchFollowupToDate) {
            searchvalue.followupToDate = searchFollowupToDate
        }
        if (searchLeadFromDate) {
            searchvalue.leadFromDate = searchLeadFromDate
        }
        if (searchLeadToDate) {
            searchvalue.leadToDate = searchLeadToDate
        }
        if (isRange) {
            if (searchFromRange) {
                searchvalue.budgetFromRange = searchFromRange
            }
            if (searchToRange) {
                searchvalue.budgetToRange = searchToRange
            }
        }


        setDownloadLoading(true)
        api
            .post(`/get_sales_pyramid_report_excel_export`, searchvalue)
            .then((response) => {
                const followupExportDataTable = !isEmpty(response.data.data)
                    ? response.data.data.map((data, index) => {
                        // serialNo = serialNo + 1

                        const eventDate = data && !isEmpty(data.eventDate) ? data.eventDate.filter(m => m != null || m != undefined)
                            .map(m => moment(m).format(dateFormat)).join(",") : "--"
                        const eventDateValue =
                            !isEmpty(eventDate) && eventDate != ","
                                ? JSON.stringify(eventDate).replace(/","/g, "\n") : "--"
                        const venueName = data.venueName
                            ? data.venueName
                            : ""
                        const venueNameValue =
                            !isEmpty(venueName) && venueName != ","
                                ? JSON.stringify(venueName).replace(/","/g, "\n") : "--"

                        const strategyRemark = !isEmpty(data.strategyRemark)
                            ? data.strategyRemark
                            : ""
                        const strategyRemarkValue = !isEmpty(strategyRemark)
                            ? strategyRemark.replace(/[\r\n,.]/gm, "")
                            : "--"
                        const isPremium = data.isPremium === true ? "Yes" : "No"
                        const zgClient = !isEmpty(data.zgPlusOneClient) ? data.zgPlusOneClient.map(m => m).join(",") : "--"
                        const zgClientValue =
                            !isEmpty(zgClient) && zgClient != ","
                                ? JSON.stringify(zgClient).replace(/","/g, "\n")
                                : "--"
                        return {
                            _id: index,
                            sNo: index + 1,
                            leadNo: data.leadNo ? data.leadNo : "--",
                            clientAppearanceRating: data.clientAppearanceRating ? data.clientAppearanceRating : "--",
                            companyName: data.companyName ? data.companyName : "--",
                            branchName: data.branchName ? data.branchName : "--",
                            followupDate: data.followupDate ? moment(data.followupDate).format(dateFormat) : "--",
                            venueName: venueNameValue,
                            eventDate: eventDateValue,
                            followupCount: data.followupCount ? data.followupCount : "--",
                            eventFollowupCount: `${data.eventDaysCount} / ${data.nextFollowupDaysCount}`,
                            isPremium: isPremium,
                            salesUrge: data.salesUrge ? data.salesUrge : "--",
                            discountPercentage: data.discountPercentage ? data.discountPercentage : "--",
                            budget: data.budgetValue,
                            processStatus: data.processStatusName ? data.processStatusName : "--",
                            clientStatus: data.clientStatus ? data.clientStatus : "--",
                            officeVisit: data.officeVisit == true ? "YES" : "NO",
                            followupMode: data.followupMode ? data.followupMode : "--",
                            clientName: data.clientName ? data.clientName : "--",
                            salesAgent: data.salesAgent ? data.salesAgent : "--",
                            mobile: data.mobile ? data.mobile : "--",
                            strategyRemark: strategyRemarkValue,
                            clientPriority: data.priorityStatusName ? data.priorityStatusName : "--",
                            agingDate: data.agingDaysCount + "/" + data.reAssigningDaysCount,
                            salesPyramid: data.salesPyramid && data.salesPyramid != null ? data.salesPyramid : "Yet To Audit",
                            leadSource: data.leadSourceName ? data.leadSourceName : "--",
                            followupHistory: data.followupHistory,
                            zgClient: zgClientValue,
                            averageFollowup: data.averageFollowup ? data.averageFollowup : "--",
                            greenFlagRemarks: data.greenFlagRemarks ? data.greenFlagRemarks : "--",
                            goodLookingClient: data.goodLookingClient == true ? "YES" : "NO",
                            highEndClient: data.highEndClient == true ? "YES" : "NO",
                        }
                    })
                    : []
                setTimeout(() => {
                    let headerData = [
                        "S.No,Lead No,Good Looking Client,High End Client,Client Appearance Rating,Company,Branch,Followup Date,Venue Name,Event Date,Followup Count,Average Followup,Event Date / Next Followup Date,Premium,Sales Urge,Discount Percentage,Total Value / Budget,Process Status,Client Status,Office Visit,Follow Up Mode,Client Name,Sales Agent,Mobile,Strategy Remark,Client Priority,Aging/Re-assigning,Pyramid Status,Lead Source,ZG +1 Clients,Green Flag Remarks"
                    ]

                    let usersCsv =
                        !isEmpty(followupExportDataTable) &&
                        followupExportDataTable.reduce((acc, user) => {
                            const {
                                sNo,
                                leadNo,
                                goodLookingClient,
                                highEndClient,
                                clientAppearanceRating,
                                companyName,
                                branchName,
                                followupDate,
                                venueName,
                                eventDate,
                                followupCount,
                                averageFollowup,
                                eventFollowupCount,
                                isPremium,
                                salesUrge,
                                discountPercentage,
                                budget,
                                processStatus,
                                clientStatus,
                                officeVisit,
                                followupMode,
                                clientName,
                                salesAgent,
                                mobile,
                                strategyRemark,
                                clientPriority,
                                agingDate,
                                salesPyramid,
                                leadSource,
                                zgClient,
                                greenFlagRemarks
                            } = user
                            acc.push([
                                sNo,
                                leadNo,
                                goodLookingClient,
                                highEndClient,
                                clientAppearanceRating,
                                companyName,
                                branchName,
                                followupDate,
                                venueName,
                                eventDate,
                                followupCount,
                                averageFollowup,
                                eventFollowupCount,
                                isPremium,
                                salesUrge,
                                discountPercentage,
                                budget,
                                processStatus,
                                clientStatus,
                                officeVisit,
                                followupMode,
                                clientName,
                                salesAgent,
                                mobile,
                                strategyRemark,
                                clientPriority,
                                agingDate,
                                salesPyramid,
                                leadSource,
                                zgClient,
                                greenFlagRemarks
                            ])

                            return acc
                        }, [])

                    downloadFile({
                        data: [...headerData, ...usersCsv].join("\n"),
                        fileName: "SalesPyramidReport.csv",
                        fileType: "text/csv",
                    })
                    setDownloadLoading(false)
                }, 2500)
                return response.data
            })
            .catch((error) => {
                Promise.reject(error)
                setDownloadLoading(false)
            })

    }
    const RemotePagination = ({
        data,
        page,
        // sort,
        sizePerPage,
        onTableChange,
        totalSize,
    }) => (
        <div>
            <PaginationProvider
                pagination={paginationFactory({
                    custom: true,
                    page,
                    // sort,
                    sizePerPage,
                    totalSize,
                })}
            >
                {({ paginationProps, paginationTableProps }) => (
                    <div>
                        <ToolkitProvider
                            keyField="_id"
                            data={data}
                            columns={columns}
                            search
                            exportCSV
                        >
                            {() => (
                                <div>
                                    <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                        <Row className="d-flex flex-row">
                                            <Col className="mb-3" md="4"></Col>
                                            {/* {downloadAccessId === "61bc3079e2e60e9919697604" ? ( */}
                                            <Col md="8" style={{ marginBottom: "20px", marginTop: "-41px" }}>

                                                <div
                                                    style={{
                                                        float: "right",
                                                        marginRight: "10px",
                                                    }}
                                                >

                                                    <Button
                                                        className="btn btn-primary"
                                                        onClick={exportToCsv}
                                                        id="download"
                                                        style={{
                                                            backgroundColor: "#e40d8c",
                                                            color: "white",
                                                            border: "none",
                                                            marginRight: "10px",
                                                        }}
                                                    >
                                                        Download
                                                    </Button>
                                                    <Button
                                                        className="btn btn-info"
                                                        onClick={() => setColumnModal(true)}
                                                    >
                                                        Edit Columns
                                                    </Button>
                                                </div>
                                            </Col>

                                            <Col>
                                                <BootstrapTable
                                                    remote
                                                    // {...props.baseProps}
                                                    keyField="_id"
                                                    data={data}
                                                    id="ImportTable"
                                                    columns={columns}
                                                    noDataIndication={"No Data Found..."}
                                                    responsive
                                                    bordered={true}
                                                    onTableChange={onTableChange}
                                                    {...paginationTableProps}
                                                />
                                            </Col>
                                        </Row>
                                        <Row
                                            style={{ marginTop: "5px" }}
                                            className="align-items-md-center mt-30"
                                        >
                                            <Col className="inner-custom-pagination d-flex">
                                                <div className="d-inline d-flex flex-row">
                                                    <SizePerPageDropdownStandalone {...paginationProps} />
                                                    <div
                                                        style={{
                                                            fontSize: "14px",
                                                            marginTop: "8px",
                                                            marginLeft: "4px",
                                                        }}
                                                    >
                                                        <PaginationTotalStandalone {...paginationProps} />
                                                    </div>
                                                </div>
                                                <div
                                                    className="text-md-right ms-auto"
                                                    style={{ zIndex: 0 }}
                                                >
                                                    <PaginationListStandalone
                                                        // paginationTotalRenderer={leave_list.totalDataCount}
                                                        {...paginationProps}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </div>
                            )}
                        </ToolkitProvider>
                    </div>
                )}
            </PaginationProvider>
        </div>
    )
    const [pageLoad, setPageLoad] = useState(false)
    const [state, setState] = useState({
        sizePerPage: 50,
        page: 1,
        totalSize: product_data.length,
        data:
            !isEmpty(product_data) && product_data.length > 0
                ? product_data.slice(0, 50)
                : [],
    })
    const { sizePerPage, page } = state

    const handleTableChange = (
        type,
        { page, sortField, sortOrder, currentIndex, sizePerPage }
    ) => {
        setPageCount(page)
        setPageChange(true)
        setPageLoad(!pageLoad)
        let result =
            !isEmpty(product_data) && product_data.length > 0
                ? product_data
                : []
        if (
            !isEmpty(employee) ||
            !isEmpty(company) ||
            !isEmpty(branch) ||
            !isEmpty(leadSource) ||
            !isEmpty(productStatusData.eventFromDate) ||
            !isEmpty(productStatusData.eventToDate) ||
            !isEmpty(productStatusData.followupFromDate) ||
            !isEmpty(productStatusData.followupToDate) ||
            !isEmpty(productStatusData.leadFromDate) ||
            !isEmpty(productStatusData.leadToDate) ||
            !isEmpty(rangeValue) ||
            !isEmpty(pyramidStatus)
        ) {
            var searchCompany = !isEmpty(company) && company ? company.value : ""
            var searchBranch = !isEmpty(branch) && branch ? branch.value : ""
            var searchSource = !isEmpty(leadSource) && leadSource ? leadSource.value : ""

            var searchEmployee = !isEmpty(employee) && employee ? employee.value : ""
            var searchPyramid = !isEmpty(pyramidStatus) && pyramidStatus ? pyramidStatus.value : ""
            var searchFromDate =
                productStatusData && productStatusData.eventFromDate
                    ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
                    : ""
            var searchToDate =
                productStatusData && productStatusData.eventToDate
                    ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
                    : ""
            var searchFromRange = !isEmpty(rangeValue) ? rangeValue[0] : ""
            var searchToRange = !isEmpty(rangeValue) ? rangeValue[1] : ""
            var searchFollowupFromDate =
                productStatusData && productStatusData.followupFromDate
                    ? moment(productStatusData.followupFromDate).format("YYYY-MM-DD")
                    : ""
            var searchFollowupToDate =
                productStatusData && productStatusData.followupToDate
                    ? moment(productStatusData.followupToDate).format("YYYY-MM-DD")
                    : ""
            var searchLeadFromDate =
                productStatusData && productStatusData.leadFromDate
                    ? moment(productStatusData.leadFromDate).format("YYYY-MM-DD")
                    : ""
            var searchLeadToDate =
                productStatusData && productStatusData.leadToDate
                    ? moment(productStatusData.leadToDate).format("YYYY-MM-DD")
                    : ""
            var searchvalue = {}
            searchvalue.page = page || pageCount
            searchvalue.limit = sizePerPage ? sizePerPage : 50

            if (searchEmployee) {
                searchvalue.salesManagerId = searchEmployee
            }
            if (searchFromDate) {
                searchvalue.eventFromDate = searchFromDate
            }
            if (searchToDate) {
                searchvalue.eventToDate = searchToDate
            }
            if (searchCompany) {
                searchvalue.companyId = searchCompany
            }
            if (searchBranch) {
                searchvalue.branchId = searchBranch
            }
            if (searchSource) {
                searchvalue.leadSourceId = searchSource
            }
            if (searchFollowupFromDate) {
                searchvalue.followupFromDate = searchFollowupFromDate
            }
            if (searchFollowupToDate) {
                searchvalue.followupToDate = searchFollowupToDate
            }
            if (searchLeadFromDate) {
                searchvalue.leadFromDate = searchLeadFromDate
            }
            if (searchLeadToDate) {
                searchvalue.leadToDate = searchLeadToDate
            }
            if (isRange) {
                if (searchFromRange) {
                    searchvalue.budgetFromRange = searchFromRange
                }
                if (searchToRange) {
                    searchvalue.budgetToRange = searchToRange
                }
            }
            if (searchPyramid) {
                searchvalue.pyramidStatus = searchPyramid
            }
            setPageLoad(!pageLoad)

            setLoading(true)
            dispatch(productAction.loadProductStatus(searchvalue))
        } else {
            dispatch(
                productAction.loadProductStatus({
                    page: page,
                    limit: sizePerPage,
                })
            )
            setLoading(true)
            setPageLoad(!pageLoad)
        }
        // setPageCount(page)
        setTimeout(() => {
            setLoading(false)
        }, 2000)
        if (sortOrder === "asc") {
            result = result.sort((a, b) => {
                if (a[sortField] > b[sortField]) {
                    return 1
                } else if (b[sortField] > a[sortField]) {
                    return -1
                }
                return 0
            })
        } else {
            result = result.sort((a, b) => {
                if (a[sortField] > b[sortField]) {
                    return -1
                } else if (b[sortField] > a[sortField]) {
                    return 1
                }
                return 0
            })
        }

        setState(() => ({
            page,
            data: result.slice(currentIndex, currentIndex + sizePerPage),
            totalSize: result.length,
            sizePerPage,
        }))
    }
    const handleCompany = (e) => {
        setCompany(e)
        setBranch([])
    }
    return (
        <div className="page-content">
            <MetaTags>
                <title>{title} | Zero Gravity CRM</title>
            </MetaTags>
            <Container fluid>
                <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
                <Row>

                    <Col md="9" lg="9" xl="9" sm="12">
                        <Card>
                            <CardBody>
                                <form>
                                    <Row>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <Label className="employee-label">Company</Label>
                                            <Select
                                                type="text"
                                                name="company"
                                                value={company}
                                                onChange={(e) => handleCompany(e)}
                                                options={
                                                    recordsMetaData ? recordsMetaData.companyOptions : []
                                                }
                                                placeholder="Select Company"
                                                classNamePrefix="select2-selection"
                                            />
                                        </Col>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <Label className="employee-label">Branch</Label>
                                            <Select
                                                type="text"
                                                name="branch"
                                                value={branch}
                                                onChange={(e) => setBranch(e)}
                                                options={branchListOptions}
                                                placeholder="Select Branch"
                                                classNamePrefix="select2-selection"
                                            />
                                        </Col>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <Label className="employee-label">Lead Source</Label>
                                            <Select
                                                type="text"
                                                name="leadSource"
                                                value={leadSource}
                                                onChange={(e) => setLeadSource(e)}
                                                options={
                                                    recordsMetaData ? recordsMetaData.leadSourceOptions : []
                                                }
                                                placeholder="Select Lead Source"
                                                classNamePrefix="select2-selection"
                                            />
                                        </Col>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event From Date"}
                                                >
                                                    {"Event From Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="eventFromDate"
                                                value={productStatusData.eventFromDate}
                                                max={productStatusData.eventToDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event To Date"}
                                                >
                                                    {"Event To Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="eventToDate"
                                                value={productStatusData.eventToDate}
                                                min={productStatusData.eventFromDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <Label className="employee-label">Sales Manager</Label>
                                            <Select
                                                type="text"
                                                name="employee"
                                                value={employee}
                                                onChange={(e) => setEmployee(e)}
                                                options={
                                                    recordsMetaData ? recordsMetaData.employeeOptions : []
                                                }
                                                placeholder="Select Sales Manager"
                                                classNamePrefix="select2-selection"
                                            />
                                        </Col>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event From Date"}
                                                >
                                                    {"Followup From Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="followupFromDate"
                                                value={productStatusData.followupFromDate}
                                                max={productStatusData.followupToDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event To Date"}
                                                >
                                                    {"Followup To Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="followupToDate"
                                                value={productStatusData.followupToDate}
                                                min={productStatusData.followupFromDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event From Date"}
                                                >
                                                    {"Lead From Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="leadFromDate"
                                                value={productStatusData.leadFromDate}
                                                max={productStatusData.leadToDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event To Date"}
                                                >
                                                    {"Lead To Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="leadToDate"
                                                value={productStatusData.leadToDate}
                                                min={productStatusData.leadFromDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <Label className="employee-label">Pyramid Status</Label>
                                            <Select
                                                type="text"
                                                name="pyramidStatus"
                                                value={pyramidStatus}
                                                onChange={(e) => setPyramidStatus(e)}
                                                options={[
                                                    { label: "Active", value: "Active" },
                                                    { label: "Inactive", value: "Inactive" },
                                                    { label: "Potential", value: "Potential" },
                                                    { label: "Hot", value: "Hot" },
                                                    { label: "Yet To Audit", value: "Yet To Audit" },

                                                ]
                                                }
                                                placeholder="Select Pyramid Status"
                                                classNamePrefix="select2-selection"
                                            />
                                        </Col>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label className={"form-label"}>{"Budget Range"}</Label>
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center mb-4">
                                                <div className="d-flex align-items-center me-3">
                                                    <span className="me-2">Min</span>
                                                    <InputNumber
                                                        min={0}
                                                        max={rangeValue[1]}
                                                        value={rangeValue[0]}
                                                        onChange={handleMinChange}
                                                        placeholder="Min"
                                                    />
                                                </div>


                                                <span className="mx-2">-</span>

                                                <div className="d-flex align-items-center">
                                                    <span className="me-2">Max</span>
                                                    <InputNumber
                                                        min={rangeValue[0]}
                                                        max={1000000}
                                                        value={rangeValue[1]}
                                                        onChange={handleMaxChange}
                                                        placeholder="Max"
                                                    />
                                                </div>
                                            </div>
                                            <Slider range
                                                min={0}
                                                max={1000000}
                                                value={rangeValue}
                                                onChange={handleRangeChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                                            <div
                                                className="filter-buttons"
                                                style={{ float: "right" }}
                                            >
                                                <Button
                                                    type="button"
                                                    className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                                                    onClick={() => {
                                                        resetForm()
                                                    }}
                                                >
                                                    <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                    Reset
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    onClick={(e) => handleFilter(e)}
                                                    className="btn btn-success btn-label simple-form-applyfilter-btn"
                                                >
                                                    <i className="bx bx-filter-alt label-icon"></i>
                                                    {btnLoader && btnLoader ? (
                                                        <ButtonSpinner />
                                                    ) : (
                                                        "Apply Filter"
                                                    )}{" "}
                                                </Button>
                                            </div>
                                        </Col>

                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="3" lg="3" xl="3" sm="12" >
                        <Card>
                            <CardBody>
                                {pyramidData.length > 0 ? (<div> <CanvasJSChart options={pyramidOptions} /></div>)
                                    : (<div>No Records Found</div>)}


                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-3">

                    <Col md="12" lg="12" xl="12" sm="12">
                        <Card>
                            <CardBody>
                                <div
                                    className="d-flex flex-row"
                                    style={{ marginTop: "20px" }}
                                >
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <form onSubmit={handleClick} className="d-flex flex-row">
                                            <div style={searchBtnStyle || null}>
                                                <Input
                                                    type="text"
                                                    name="searchInput"
                                                    value={searchInput}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Search"
                                                    style={{ position: "relative" }}
                                                />
                                                <i
                                                    className="bx bx-search-alt"
                                                    style={{
                                                        position: "absolute",
                                                        top: "54px",
                                                        left: "41px",
                                                        fontSize: "13px",
                                                    }}
                                                />
                                            </div>
                                            <Button
                                                type="submit"
                                                style={{
                                                    background: searchFilter ? "#2ca67a" : "",
                                                    color: searchFilter ? "#2ca67a" : "",
                                                }}
                                                className="btn btn-success mx-2"
                                            >
                                                <i className="fas fa-search"></i>
                                            </Button>
                                        </form>
                                    </div>
                                </div>{" "}
                                <RemotePagination
                                    data={productStatusTable}
                                    page={page}
                                    sizePerPage={sizePerPage}
                                    totalSize={product_data.totalDataCount ? product_data.totalDataCount : 0}
                                    onTableChange={handleTableChange}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {columnModal && (
                <Modal size="xl" show={columnModal}>
                    <Modal.Header
                        style={{
                            backgroundColor: "white",
                            color: "black",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        Edit Columns
                        <span>
                            <i
                                className="fa fa-times quote-close"
                                aria-hidden="true"
                                onClick={() => setColumnModal(false)}
                            ></i>
                        </span>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <div>
                                <Input
                                    type="checkbox"
                                    checked={
                                        selectedColumns.length === columns.length
                                    }
                                    onChange={(e) => handleSelectAllChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                />
                                <Label
                                    style={{ fontSize: "16px", marginLeft: "10px" }}
                                >
                                    Select All
                                </Label>
                            </div>
                        </Row>
                        <Row>
                            <Col sm="12" md="6" lg="6" className="ml-4">
                                {oddColumnData.map((column) => (
                                    <div
                                        key={column.dataField}
                                        className="d-flex flex-row"
                                    >
                                        <div className="form-check form-check-inline">
                                            <Input
                                                type="checkbox"
                                                value={column.dataField}
                                                checked={selectedColumns.includes(
                                                    column.dataField
                                                )}
                                                onChange={(e) => handleCheckboxChange(e)}
                                                style={{ width: "15px", height: "15px" }}
                                            />
                                            <Label
                                                style={{
                                                    fontSize: "16px",
                                                    marginLeft: "10px",
                                                }}
                                            >
                                                {column.text}
                                            </Label>
                                        </div>
                                    </div>
                                ))}
                            </Col>
                            <Col sm="12" md="6" lg="6">
                                {evenColumnData.map((column) => (
                                    <div
                                        key={column.dataField}
                                        className="d-flex flex-row"
                                    >
                                        <div className="form-check form-check-inline">
                                            <Input
                                                type="checkbox"
                                                value={column.dataField}
                                                checked={selectedColumns.includes(
                                                    column.dataField
                                                )}
                                                onChange={(e) => handleCheckboxChange(e)}
                                                style={{ width: "15px", height: "15px" }}
                                            />
                                            <Label
                                                style={{
                                                    fontSize: "16px",
                                                    marginLeft: "10px",
                                                }}
                                            >
                                                {column.text}
                                            </Label>
                                        </div>
                                    </div>
                                ))}
                            </Col>
                        </Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <p
                            className="text-decoration-underline text-info"
                            style={{ cursor: "pointer", fontSize: "16px" }}
                            onClick={handleRestoreToDefault}
                        >
                            Restore To Default
                        </p>
                        <Button
                            variant="secondary"
                            className="btn btn-danger"
                            data-bs-dismiss="modal"
                            onClick={() => {
                                setColumnModal(false)
                                setSelectedColumns(selectColumn)
                            }}
                        >
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            className="btn btn-success"
                            onClick={() => handleSaveColumns()}
                        >
                            Submit
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            {loading ? (
                <Modal
                    show={loading}
                    style={{ width: "6.7%", margin: "18% 50%" }}
                >
                    <Modal.Body>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                        />
                        {/* <span>Loading...</span> */}
                    </Modal.Body>
                </Modal>
            ) : (
                ""
            )}
            {downloadLoading ? (
                <Modal
                    show={downloadLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                >
                    <Modal.Body>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                        />
                    </Modal.Body>
                </Modal>
            ) : (
                ""
            )}

            {pyramidModal && (
                <Modal size="xl" show={pyramidModal}>
                    <Modal.Header
                        style={{
                            backgroundColor: "#E40D8C",
                            color: "white",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        Sale Pyramid History
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="mt-3">
                            <Table>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Sales Pyramid Status</th>
                                        <th>Created By Name</th>
                                        <th>Created Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {salesPyramidDetails && !isEmpty(salesPyramidDetails) ?
                                        salesPyramidDetails.map((data, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index}</td>
                                                    <td>{data.salesPyramid ? data.salesPyramid : "--"}</td>
                                                    <td>{data.salesPyramidOn ? moment(data.salesPyramidOn).format(dateFormat

                                                    ) : "--"}</td>
                                                    <td>{data.salesPyramidByName ? data.salesPyramidByName : "--"}</td>
                                                </tr>
                                            )
                                        })
                                        : <tr key={0}>
                                            <td className="text-align-center" colSpan={4}>
                                                No Records Found...
                                            </td>
                                        </tr>}

                                </tbody>
                            </Table>
                        </Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            className="btn btn-danger"
                            data-bs-dismiss="modal"
                            onClick={() => setPyramidModal(false)}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            {followupHistoryModal && (
                <Modal show={followupHistoryModal} onHide={handleFollowupHistoryModal} size="lg">
                    <Modal.Header
                        style={{
                            backgroundColor: "#E40D8C",
                            color: "white",
                            minHeight: "65px",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        <Col
                            xl="6"
                            lg="6"
                            md="6"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                        >
                            <span>Followup History</span>
                            {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
                        </Col>
                    </Modal.Header>
                    <Modal.Body>

                        <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">

                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th >Followup Status</th>
                                        <th >Followup Date</th>
                                        <th >Followup No</th>
                                        <th >Followup Mode</th>
                                        <th >Followup Remarks</th>
                                        <th >Followup Attachment</th>
                                        <th>Future Followup Date</th>
                                        <th>Future Followup Mode</th>
                                        {/* <th>Future Followup Remarks</th> */}
                                        <th>Future Followup Strategy</th>
                                        <th>Strategy Remark</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {followupHistoryDetails && !isEmpty(followupHistoryDetails) ?
                                        followupHistoryDetails.map((item, index) => {

                                            const attachment = !isEmpty(item.recordAttachment)
                                                ? item.recordAttachment[0]
                                                : ""
                                            const attachExtension = !isEmpty(attachment)
                                                ? attachment.split(".").pop()
                                                : ""



                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.followupStatusName ? item.followupStatusName : "--"}</td>
                                                    <td>{item.followupDate ? moment(item.followupDate).format(dateFormat) : "--"}</td>
                                                    <td>{item.followwupNo ? item.followwupNo : "--"}</td>
                                                    <td>{item.modeName ? item.modeName : "--"}</td>
                                                    <td>{item.remarks ? item.remarks : "--"}</td>
                                                    <td>
                                                        {" "}
                                                        {(attachment &&
                                                            attachExtension === "jpeg") ||
                                                            (attachment &&
                                                                attachExtension === "jpg") ||
                                                            (attachment &&
                                                                attachExtension === "png") ? (
                                                            <div className="d-flex flex-row align-items-center">
                                                                <a
                                                                    onClick={() =>
                                                                        window.open(
                                                                            attachment,
                                                                            "_blank"
                                                                        )
                                                                    }
                                                                >
                                                                    <span
                                                                        style={{
                                                                            textDecoration: "underline",
                                                                            color: "#E40D8C",
                                                                        }}
                                                                    >
                                                                        View
                                                                    </span>
                                                                </a>

                                                            </div>
                                                        ) : (attachment &&
                                                            attachExtension === "mp3") ||
                                                            (attachment &&
                                                                attachExtension === "m4a") ||
                                                            (attachment &&
                                                                attachExtension === "mp4") ? (
                                                            <a href={attachment}>
                                                                <audio controls>
                                                                    <source
                                                                        src={attachment}
                                                                        type="audio/mpeg"
                                                                    />
                                                                    Your browser does not support the
                                                                    audio element.
                                                                </audio>
                                                            </a>
                                                        ) : (
                                                            "--"
                                                        )}
                                                    </td>
                                                    <td>{item.futureFollowup.followupDate ? moment(item.futureFollowup.followupDate).format(dateFormat) : "--"}</td>

                                                    <td>{item.futureFollowup.futureFollowupmodeName ? item.futureFollowup.futureFollowupmodeName : "--"}</td>
                                                    <td>{item.futureFollowup.strategyRemark ? item.futureFollowup.strategyRemark : "--"}</td>
                                                </tr>)

                                        }) :
                                        <tr>
                                            <td className="text-align-center" colSpan={11}>
                                                No Records Found...
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex flex-row">
                            <Button
                                variant="secondary"
                                className="btn btn-danger"
                                onClick={handleFollowupHistoryModal}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="secondary"
                                className="btn btn-success mx-2"
                                onClick={handleFollowupHistoryModal}
                            >
                                Submit
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            )}
            <ToastContainer
                position="top-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    )
}
SalesPyramidReports.propTypes = {
    dispatch: PropTypes.func,
    recordsMetaData: PropTypes.array,
    searchProps: PropTypes.func,
    onSearch: PropTypes.func,
    onExport: PropTypes.func,
    baseProps: PropTypes.any,
    searchBtnStyle: PropTypes.any,
    csvProps: PropTypes.any,
    pageClick: PropTypes.any,
    data: PropTypes.array.isRequired,
    page: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    totalSize: PropTypes.number.isRequired,
    sizePerPage: PropTypes.number.isRequired,
    onTableChange: PropTypes.func.isRequired,
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    // employee: state.employeeRequest.employee,SalesPyramidReports
})
//SalesPyramidReports
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SalesPyramidReports)
)
